/**
 * Use a prop replacer to strip out component ref since it's a circular reference,
 * and can cause crashes during memoization
 */
export const memoizationPropReplacer = (key: string, value: any) => {
  if (key === 'componentRef') {
    return undefined;
  }
  return value;
};
